import {
  Box,
  Typography,
  Grid,
} from '@material-ui/core';

const UnauthorizedMessage: React.FC = () => (
  <Box m={1}>
    <Grid container justifyContent="center" alignItems="center">
      <Grid item>
        <Box my={1}>
          <Typography align="center" variant="h4">
            {'Your account does not have access to this page. '}
          </Typography>
          <Typography align="center" variant="h4">
            {'Please talk to your manager to ensure you have the permissions you need. '}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default UnauthorizedMessage;
